export type CompetitorDomainRejectionCode =
  "INVALID_HOSTNAME" | "IP_LITERAL_NOT_ALLOWED" | "INTERNAL_HOST_NOT_ALLOWED" | "DOMAIN_BLOCKED";

export const COMPETITOR_DOMAIN_NORMALIZATION_VERSION = 1;
export const COMPETITOR_DOMAIN_MATCH_MODE_EXACT_HOST = "EXACT_HOST";
export const COMPETITOR_DOMAIN_MATCH_MODE_ROOT_DOMAIN = "ROOT_DOMAIN";
export const COMPETITOR_DOMAIN_MATCH_MODE_APPROVED_SUBDOMAINS = "APPROVED_SUBDOMAINS";
export const COMPETITOR_DOMAIN_MATCH_MODES = [
  COMPETITOR_DOMAIN_MATCH_MODE_EXACT_HOST,
  COMPETITOR_DOMAIN_MATCH_MODE_ROOT_DOMAIN,
  COMPETITOR_DOMAIN_MATCH_MODE_APPROVED_SUBDOMAINS,
] as const;
export type CompetitorDomainMatchMode = (typeof COMPETITOR_DOMAIN_MATCH_MODES)[number];

export interface NormalizedCompetitorDomain {
  input: string;
  canonicalHost: string;
  normalizedHost: string;
  rootDomain: string;
  canonicalUrl: string;
  normalizationVersion: typeof COMPETITOR_DOMAIN_NORMALIZATION_VERSION;
}

export interface CompetitorDomainPolicyInput {
  globalBlockedDomains?: readonly string[];
  merchantBlockedDomains?: readonly string[];
  merchantAllowedDomains?: readonly string[];
}

export interface CompetitorDomainPolicyDecision {
  allowed: boolean;
  reasonCode?: CompetitorDomainRejectionCode;
}

export interface CompetitorDomainRule {
  canonicalHost: string;
  rootDomain: string;
  domainMatchMode: CompetitorDomainMatchMode;
  approvedSubdomainPatterns?: readonly string[];
}
